<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<p class="center"><em class="italic">For my other set of sisters Denise, Karen, Carol, Lynette, Carol Sue, Cheryl, and Catherine</em></p>
<a id="page_iv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?06bbef96